/**
 * Compete — the tab that is still a placeholder. (Learn was one too until Phase 9.)
 *
 * ========================= WHY THEY ARE HERE AT ALL ============================
 * Because the four tabs are the same four in every room, and a room with two tabs today
 * and four in a month teaches the player the shape twice. Each of these says exactly
 * what is coming, from the plan that is actually going to build it — the Learn panel
 * lists the shelves and titles out of `plan/content/LEARN-OUTLINE.md`, the Compete panel
 * names the three surfaces from the master plan §4 — so a player reading it learns
 * something true rather than "coming soon".
 *
 * The Learn titles are TRANSCRIBED, not imported: the outline is a planning document
 * outside the repo, the library will be built from a lesson source inside it (Phase L),
 * and this panel is replaced the day that source exists.
 * ===============================================================================
 */
import "./rooms.css";

/*
 * PHASE 9: `LearnPanel` is gone — the Learn tab renders from the lesson source now
 * (`learn/LearnTab.tsx`), and the outline it transcribed moved with it
 * (`learn/library.ts`, `OUTLINE`). Compete is still the placeholder below.
 */

export function CompetePanel() {
  return (
    <div className="tab-compete">
      <section className="panel">
        <h2>Daily Spot · Trainer Rush · Weekly League — coming</h2>
        <ul className="compete-list">
          <li><b>Daily Spot</b> — one decision, the same for everyone, resets at midnight.</li>
          <li><b>Trainer Rush</b> — three minutes of spots, one strike and you are out.</li>
          <li><b>Weekly League</b> — a bracket on Trainer Rating movement.</li>
        </ul>
        <p className="muted small">
          The board that counts is <b>Trainer Rating</b>, which scores EV lost and not
          outcome. A Bucks board is net won since Monday with refills excluded, drawn as
          a chalkboard — a chip count on refillable play money is a slot machine with a
          scoreboard, and it is not going to be one here.
        </p>
      </section>
    </div>
  );
}
